import { SVGProps } from 'react';

const ChevronLeft = ({
  props,
  fill = 'currentColor',
  size = 20,
}: {
  props?: SVGProps<SVGSVGElement>;
  fill?: string;
  size?: string | number;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill={fill}
      d="M14.293 5.293a1 1 0 1 1 1.414 1.414L10.414 12l5.293 5.293a1 1 0 1 1-1.414 1.414l-6-6a1 1 0 0 1 0-1.414l6-6Z"
    />
  </svg>
);

export default ChevronLeft;
